export default __webpack_public_path__ + "static/media/spacecowboy2.d52d1d4c.png";